// src/pages/menu/AfricanTablesAndOrdersDashboard.jsx
import React from 'react';
import LocationTablesAndOrdersDashboard from '../TablesAndOrdersDashboard';

const AfricanTablesAndOrdersDashboard = () => {
  return <LocationTablesAndOrdersDashboard locationKey="african" />;
};

export default AfricanTablesAndOrdersDashboard;